import React from 'react';
import WName, {WArticle} from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR} from '../common';

// SAFETY!!!!!!!!11
export const safety = {
  name: "safety",
  parentName: <span>Safety<sup>®</sup> culture</span>,
  prelude: <span>
    Who doesn’t yearn to be <i>safe</i>?
  </span>,
  header: <span>
    Safety<sup>®</sup> culture is killing us.
  </span>,
  outside: <span>
    And not-so-slowly; in just the past few years – since the ‘public’ <QL name="polygnosticity.">release</QL> of <QL>Gippity</QL> – we’ve progressed towards <AL>Hell</AL> at a rate that is, frankly, ‘alarming’.
  </span>,
  preview: <div className="problem-preview">
    <p>So what’s the problem, eejit-<NW>zyzzyva</NW>, with Safety<sup>®</sup>?</p>.
    <p>The problem is <QL name="TM">the ®</QL>.</p>
    <p>Why? (A <WName ist /> always asks: ‘Why?’)</p>
    <p>Because the <NW>MNS system</NW> doesn’t run on <QL>resilience</QL>. The MNS system runs on RigidBoxing<sup>™</sup>: <PL>containment</PL>.</p>
  </div>,
  text: <div className="problem-text">
    <p>There are plenty of (<AL name="fields.">mathematical</AL>) reasons that show containment-mindedness is logically inconsistent. The ‘<LRL name="cantor">nepantla proof</LRL>’, for one. You can never have an enumerated ‘all’ of <PL name="infinity">∞ (infinity)</PL>. Therefore if you try to achieve safety by <i>restriction</i> (cf. <NW>APE</NW>), you will either leave something out of your list (<LRL name="cantor">nepantla</LRL>) or reduce the <QL name="i.">non-finite</QL> <QL>imagination</QL> to finitude.</p>
    <p>That one’s called the <LRL>CT</LRL> (Continuum Theorem).</p>
    <p>QED.</p>
  </div>,
//  sublist: [

  // Is EVERYTHING 'individual greed'?
/*  {
    name: "Einzelgier",
    alternatives: "ig,individual greed",
    prelude: <span>
    </span>,
    header: <span>
    </span>,
    outside: <span>
    </span>,
    preview: <div className="problem-preview">
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },*/


//  ],
};
